// Builds a one-line full address from structured pieces.
// Skips empty pieces and joins with " · ".

const joinNonEmpty = (parts, sep = ' · ') => parts.filter(p => p && String(p).trim()).join(sep);

export const formatPickupAddress = (b = {}) => {
  return joinNonEmpty([
    b.pickup_address,
    b.pickup_area && `Area: ${b.pickup_area}`,
    b.pickup_landmark && `Landmark: ${b.pickup_landmark}`,
    b.pickup_pincode && `PIN ${b.pickup_pincode}`
  ]);
};

export const formatDeliveryAddress = (b = {}) => {
  return joinNonEmpty([
    b.delivery_address,
    b.delivery_area && `Area: ${b.delivery_area}`,
    b.delivery_landmark && `Landmark: ${b.delivery_landmark}`,
    b.delivery_pincode && `PIN ${b.delivery_pincode}`
  ]);
};
